export const DuoClairMark = ({ className = "w-8 h-8" }) => (
  <img
    src="/brand/dc-logo.png"
    alt="DuoClair"
    className={`${className} object-contain shrink-0`}
    data-testid="duoclair-mark"
  />
);

export const DuoClairLogo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="duoclair-logo">
    <DuoClairMark className={compact ? "w-8 h-8" : "w-10 h-10"} />
    <div className="leading-none">
      <span className="chrome-text font-sans font-extrabold text-lg sm:text-xl tracking-tight">
        DuoClair
      </span>
      {!compact && (
        <span className="block tagline-elegant text-[8px] mt-1.5">Marketing Locale</span>
      )}
    </div>
  </div>
);
